<script>
	export let disabled = false;
	export let href = '';
	export let title = '';
	export let target = '';

	$: tag = href && !disabled ? 'a' : 'div';

	$: anchorAttrs = {
		href,
		target
	};
</script>

<svelte:element
	this={tag}
	class="icon-wrapper"
	class:disabled
	{title}
	{...anchorAttrs}
	on:click
	on:keydown
	role="none"
>
	<slot />
</svelte:element>

<style>.icon-wrapper{--size:var(--icon-size, 1.25rem);--fill:var(--icon-fill, hsla(var(--hsl-primary)));--stroke:var(--icon-stroke, hsla(var(--hsl-primary)));border-radius:2rem;background:var(--icon-wrapper-background,
			linear-gradient(hsla(var(--hsl-primary), 0.15), hsla(var(--hsl-primary), 0.15)),
			linear-gradient(hsla(var(--hsl-white)), hsla(var(--hsl-white)))
		);cursor:pointer;display:inline-grid;padding:.625rem;padding:var(--icon-wrapper-padding, 0.625rem);align-items:center;justify-items:center;place-items:center;transition:background var(--time-xs) ease-out}.icon-wrapper:hover:not(.disabled){background:var(--icon-wrapper-background-hover,
				linear-gradient(hsla(var(--hsl-primary), 0.25), hsla(var(--hsl-primary), 0.25)),
				linear-gradient(hsla(var(--hsl-white)), hsla(var(--hsl-white)))
			)}.icon-wrapper.disabled{cursor:not-allowed;pointer-events:none}</style>
